import type { SdkOperatingSystem } from './getOperatingSystem.types';

/**
 * Detects the operating system from `navigator.userAgent` for web environments.
 *
 * The React Native bundler (Metro) resolves `getOperatingSystem.native.ts`
 * instead when building for React Native, which uses `Platform.OS` directly.
 *
 * Falls back to `'unknown'` when `navigator` is unavailable (SSR, service
 * workers) or when the user-agent string doesn't match a known OS pattern.
 * @notInstrumented
 */
export const getOperatingSystem = (): SdkOperatingSystem => {
  try {
    // eslint-disable-next-line no-restricted-globals
    const ua = navigator.userAgent;

    if (/iPhone|iPad|iPod/.test(ua)) return 'ios';
    if (/Android/.test(ua)) return 'android';
    if (/Windows/.test(ua)) return 'windows';
    if (/Macintosh|Mac OS X/.test(ua)) return 'macos';
    if (/Linux/.test(ua)) return 'linux';

    return 'unknown';
  } catch {
    return 'unknown';
  }
};
